import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class UtilityService {
    // store data in session and local storage /////////////////////////////////////////////////////
    isStorageSupported(): boolean {
        try {
            sessionStorage['STORAGE_TEST'] = 'SESSION_STORAGE_TEST';
            sessionStorage.removeItem('STORAGE_TEST');
            localStorage['STORAGE_TEST'] = 'LOCAL_STORAGE_TEST';
            localStorage.removeItem('STORAGE_TEST');
            return true;
        } catch (e) {
            return false;
        }
    }

    getSessionStorageItem(key: string): string {
        if (this.isStorageSupported()) {
            return sessionStorage[key];
        }
        return null;
    }

    setSessionStorageItem(key: string, value: string): void{
        if (this.isStorageSupported()) {
            sessionStorage[key] = value;
        }
    }

    removeSessionStorageItem(key: string): void{
        if (this.isStorageSupported()) {
            sessionStorage.removeItem(key);
        }
    }

    clearSessionStorage(): void{
    }

    getLocalStorageItem(key: string): string {
        if (this.isStorageSupported()) {
            return localStorage[key];
        }
        return null;
    }

    setLocalStorageItem(key: string, value: string): void {
        if (this.isStorageSupported()) {
            localStorage[key] = value;
        }
    }

    removeLocalStorageItem(key: string): void {
        if (this.isStorageSupported()) {
            localStorage.removeItem(key);
        }
    }

    clearLocalStorage(): void {
        this.removeLocalStorageItem('clientId');
        this.removeLocalStorageItem('clientSecret');
    }
}
